import copy from 'copy-to-clipboard';

export default class CopyClipboard {

    static initializeEvents() {
        Array
            .from(document.querySelectorAll('[data-copy-clipboard-html]'))
            .forEach(button => {
                button.addEventListener('click', event => {
                    event.preventDefault();

                    const htmlToCopy = event.target.getAttribute('data-copy-clipboard-html');
                    copy(htmlToCopy, {format: 'text/html'});

                    alert('Copié dans le presse-papier.');
                });
            });

        Array
            .from(document.querySelectorAll('[data-copy-clipboard]'))
            .forEach(button => {
                button.addEventListener('click', event => {
                    event.preventDefault();

                    copy(
                        event.target.getAttribute('data-copy-clipboard'),
                        {format: 'text/plain'}
                    );
                });
            });
    }

}